import Papa, {ParseConfig, ParseResult} from 'papaparse'

export interface CsvConfig<T>
  extends Omit<ParseConfig<T>, 'complete' | 'error'> {}

export const fetchCsv = <T>(url: string, config?: CsvConfig<T>) =>
  new Promise<ParseResult<T>>((resolve, reject) => {
    // @ts-ignore
    Papa.parse<T>(url, {
      complete(data) {
        return resolve(data)
      },
      error(error: Error) {
        return reject(error)
      },
      dynamicTyping: true,
      ...config,
    })
  })

export const downloadCsv = (
  data: {
    [key: string]: string | number
  }[],
) => {
  let csv = Papa.unparse(data)

  // Prepend BOM for Excel compatibility
  csv = '\uFEFF'.concat(csv)

  // Create Blob
  const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'})

  // Create a downloadable link
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)
  link.href = url
  link.download = 'data.csv'

  // Trigger the download
  link.click()

  // Cleanup
  URL.revokeObjectURL(url)
}
